import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles  } from '@mui/styles';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import {
  CheckBox,
  Save,
  DeleteForever
} from '@mui/icons-material';

const styles = theme => ({
  columnsActions: {
    background: theme.palette.grey[100],
    padding: 1
  },
  noPadding: {
    padding: 0
  },
  view: {
    padding: 20
  }
});

class ColumnSettings extends Component {

  getColumnList = () => {
    const { columns } = this.props;
    return columns.map(col => {
      return (
        <FormControlLabel
          key={col.id}
          control={(
            <Checkbox
              type="checkbox"
              checked={col.visible}
              onChange={this.props.onChange(col)}
              value={col.id}
              color="primary"
            />
          )}
          label={col.label}
        />
      );
    })
  }

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div className={classes.columnsActions}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Grid item className={classes.noPadding}>
              <Tooltip title="Show All" placement="top">
                <IconButton color="primary" onClick={this.props.onShowAll} size="large">
                  <CheckBox />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item className={classes.noPadding}>
              <Tooltip title="Save" placement="top">
                <IconButton color="primary" onClick={this.props.onSave} size="large">
                  <Save />
                </IconButton>
              </Tooltip>
            </Grid>
            <Grid item className={classes.noPadding}>
              <Tooltip title="Reset/Delete" placement="top">
                <IconButton color="primary" onClick={this.props.onDelete} size="large">
                  <DeleteForever />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
        </div>

        <div className={classes.view}>
          <FormGroup>
            {this.getColumnList()}
          </FormGroup>
        </div>
      </div>
    );
  }
}

ColumnSettings.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default withStyles(styles)(ColumnSettings);

